import React from 'react';
import { Box } from 'rebass';
import { transparentize } from "@theme-ui/color";
import { last } from 'ramda';

/**
 * Return true if element title should be visually hidden.
 */
export function isTitleHidden(webformAttributes) {
	return webformAttributes.title_display === 'invisible'
}

export function getTileStyle(webformAttributes) {
	if (isTitleHidden(webformAttributes)) {
		return {
			position: 'absolute',
			overflow: 'hidden',
			clip: 'rect(1px,1px,1px,1px)',
			width: '1px',
			height: '1px',
			wordWrap: 'normal'
		}
	}

	return undefined
}

export function getTitleDisplay(webformAttributes) {
	return webformAttributes.title_display === 'after' ? 'after' : 'before'
}

export function isElementHidden(states) {
	return states.invisible === true || states.visible === false
}

const ElementWrapper = ({ children, settings, error, labelFor, full = false, labelClassName, color, columns, ...props }) => {
	const { states, attributes, pure } = settings;

	if (states && isElementHidden(states)) {
		return <></>
	}

	if (pure) {
		return <>{children}</>
	}

	const label = (
		<Box as="label" mb={1} sx={{ display: 'inline-block' }} style={getTileStyle(attributes)} className={labelClassName} htmlFor={labelFor}>
			{attributes.title}
			{attributes.required && (attributes.title && last(attributes.title) !== '*')? '*' : null}
		</Box>
	);

	const classNames = ['form-group', error != null && 'is-invalid', props.className].filter(item => typeof item === 'string').join(' ');

	const placeholderStyles = {
		color: transparentize(color, 0.5),
	};

	return (
		<Box
			mb={2}
			{...props}
			color={color}
			className={classNames}
			fontSize={1}
			sx={{
				position: 'relative', flexBasis: ['100%', null, `${Math.floor(10000 / columns) / 100}%`], ':not(:last-of-type)': { mb: 3 },
				'input, .input, textarea, select': {
					borderColor: transparentize(color, 0.8),
					'&::-webkit-input-placeholder': placeholderStyles,
					'&:-moz-placeholder': placeholderStyles,
					'&:-ms-input-placeholder': placeholderStyles,
				},
			}}
			px={2}
		>
			{getTitleDisplay(attributes) === 'before' && label}

			{children}

			{getTitleDisplay(attributes) === 'after' && label}

			{error && (
				<Box color="error" mt={1} {...props} dangerouslySetInnerHTML={{ __html: error }} />
			)}

			{attributes.description && (
				<div className="form-text description" {...props} dangerouslySetInnerHTML={{ __html: attributes.description }} />
			)}
		</Box>
	)
};

export default ElementWrapper
